const CookieRefresh = () => {
    function getCookiebotConsentState() {
        if (!window.Cookiebot || !window.Cookiebot.consent) {
            return '';
        }

        return JSON.stringify({
            necessary: window.Cookiebot.consent.necessary,
            preferences: window.Cookiebot.consent.preferences,
            statistics: window.Cookiebot.consent.statistics,
            marketing: window.Cookiebot.consent.marketing,
        });
    }

    function reloadAfterCookiebotConsent() {
        var currentConsentState = getCookiebotConsentState();
        var previousConsentState = sessionStorage.getItem('cookiebotConsentState');

        sessionStorage.setItem('cookiebotConsentState', currentConsentState);

        if (previousConsentState && previousConsentState !== currentConsentState) {
            window.location.reload();
        }
    }

    window.addEventListener('CookiebotOnAccept', reloadAfterCookiebotConsent);
    window.addEventListener('CookiebotOnDecline', reloadAfterCookiebotConsent);
};

export default CookieRefresh;
